/**
 * Directive to add no-newsletter class in case of missing newsletter module
 */
export const footerspacement = {
  name: 'footerspacement',
  bind: (el) => {
    const newsletterSection = el.querySelector('.footer-newsletter');
    if (!newsletterSection) {
      el.classList.add('no-newsletter');
    }
  }
};
